import { createRef, useEffect, useRef } from 'react';
import RoomListEntry from './roomListEntry';
const RoomList = ({ date, rooms, onBookingClick, availabilityDate, onRoomClick }) => {
  const scrollRefs = useRef([]);

  const handleScroll = (sourceIndex) => (e) => {
    if (window.innerWidth < 768) return;
    
    scrollRefs.current.forEach((ref, i) => {
      if (i !== sourceIndex && ref?.current) {
        ref.current.scrollLeft = e.target.scrollLeft;
      }
    });
  };

  function getInitialScroll() {
    const now = new Date();
    const totalMinutes = now.getHours() * 60 + now.getMinutes();
    let percent = totalMinutes / (24 * 60);
    
    // Bias the scroll 5% to the future for mobile and 0.2 for desktop
    const bias = window.innerWidth < 768 ? 0.05 : 0.2;
    return percent + 0.20 > 1 ? 1 : percent + bias;
  }

  useEffect(() => {
    const percent = getInitialScroll();

    scrollRefs.current.forEach(ref => {
      if (ref?.current) {
        const maxScrollLeft = ref.current.scrollWidth - ref.current.clientWidth;
        ref.current.scrollLeft = percent * maxScrollLeft;
      }
    });
  }, [rooms])

  useEffect(() => {
    if (!availabilityDate) return;

    const totalMinutes = availabilityDate[0].getHours() * 60 + availabilityDate[0].getMinutes();
    const percent = totalMinutes / (24 * 60);

    scrollRefs.current.forEach(ref => {
      if (ref?.current) {
        const maxScrollLeft = ref.current.scrollWidth - ref.current.clientWidth;
        ref.current.scrollLeft = percent * maxScrollLeft;
      }
    });
  }, [availabilityDate])

  return (
    <div className="flex flex-col md:gap-4 md:mt-4 md:mb-2">
      {rooms.map((room, index) => {
        if (!scrollRefs.current[index]) {
          scrollRefs.current[index] = createRef();
        }

        return <RoomListEntry date={date} 
            room={room}
            onBookingClick={onBookingClick}
            onScroll={handleScroll(index)}
            ref={scrollRefs.current[index]}
            availabilityDate={availabilityDate}
            onRoomClick={onRoomClick}
            key={room.id}
        />
      }
      )}
    </div>
  );
};

export default RoomList;
